"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Root = require("./Root");
Object.keys(_Root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Root[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Root[key];
    }
  });
});
